import React from 'react';
import { motion } from 'framer-motion';
import { CONSTANTS } from '../data.js';

const BattleResultScreen = ({ battle, onContinue, onRetry }) => {
  const isVictory = battle.result === 'victory';
  const isTie = battle.result === 'tie';
  const penalty = Math.floor(battle.initialCoins * CONSTANTS.BATTLE_LOSS_PENALTY_PERCENTAGE);

  return (
    <motion.div
      className="fixed inset-0 bg-black/80 backdrop-blur-lg flex items-center justify-center z-50"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        initial={{ scale: 0.5, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.5, opacity: 0 }}
        className={`bg-gray-900/80 border-2 rounded-2xl p-8 text-center max-w-md shadow-2xl ${
          isVictory ? 'border-green-500/50 shadow-green-500/20' : 
          isTie ? 'border-yellow-500/50 shadow-yellow-500/20' :
          'border-red-500/50 shadow-red-500/20'
        }`}
      >
        <h2 className={`text-5xl font-mono font-bold mb-4 text-glow ${
          isVictory ? 'text-green-400' : 
          isTie ? 'text-yellow-400' :
          'text-red-400'
        }`}>
          {isVictory ? 'Victory!' : isTie ? 'Tie!' : 'Defeat'}
        </h2>
        <p className="text-gray-300 mb-6 text-lg">
          {isVictory ? `You won the battle against ${battle.opponent.name}.` :
           isTie ? `You tied with ${battle.opponent.name}.` :
           `You lost the battle against ${battle.opponent.name}.`}
        </p>
        <div className="bg-black/30 p-4 rounded-lg mb-8">
          <h3 className="text-xl font-semibold mb-3">
            {isVictory ? 'Rewards' : isTie ? 'No Rewards' : 'Penalties'}
          </h3>
          {isVictory ? (
            <p className="text-green-400 text-2xl font-bold">+{CONSTANTS.BATTLE_REWARD_KEYS} 🗝️</p>
          ) : isTie ? (
            <p className="text-yellow-400 text-lg">No rewards or penalties for a tie</p>
          ) : (
            <p className="text-red-400 text-2xl font-bold">-{penalty.toLocaleString()} Coins</p>
          )}
        </div>
        <div className="flex justify-center space-x-4">
          <button onClick={onContinue} className="btn btn-primary px-8 py-3">
            Continue
          </button>
          <button onClick={onRetry} className="btn btn-secondary px-8 py-3">
            Retry
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default BattleResultScreen;
